import axios from 'axios';

const checkExistingUserById = async (userId: string) => {
  const {
    data: { exists },
  } = await axios.get(`/brokerbay_admin/check/user_id/${userId}`);

  return { exists };
};

export default checkExistingUserById;
